import ValidationErrors from '../../types/UI/ValidationErrors';
import Banner from '../Banner/Banner';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import Stack from '../Stack/Stack';
import UnorderedList from '../UnorderedList/UnorderedList';

const filterErrorsKeys = (
    errors?: ValidationErrors,
    exclude?: Array<string>
) => {
    if (!errors) {
        return [];
    }

    const errorKeys = Object.keys(errors);

    if (!exclude || exclude.length === 0) {
        return errorKeys;
    }

    return errorKeys.filter((key) => {
        const excludedKeyMatch = exclude.find((excludedKey) => {
            if (excludedKey.indexOf('.*') < 0) {
                return key === excludedKey;
            }

            return !!key.match(new RegExp(excludedKey));
        });

        return !excludedKeyMatch;
    });
};

type UncaughtErrorsProps = {
    exclude?: Array<string>;
    errors: ValidationErrors | undefined;
    compact?: boolean;
};

const UncaughtErrors = ({
    errors,
    compact,
    exclude = [],
}: UncaughtErrorsProps) => {
    const filteredErrorKeys = filterErrorsKeys(errors, exclude);
    if (!errors || filteredErrorKeys.length === 0) {
        return null;
    }

    if (compact) {
        return (
            <ErrorMessage>
                {filteredErrorKeys.map((key) => errors[key]).join(', ')}
            </ErrorMessage>
        );
    }

    return (
        <Stack space="xsmall">
            {filteredErrorKeys.map((key) => {
                const scopedErrors = errors[key]!;
                if (scopedErrors.length <= 1) {
                    return (
                        <Banner key={`${key}_single`} level="error">
                            {scopedErrors}
                        </Banner>
                    );
                }

                return (
                    <Banner key={key} level="error">
                        <UnorderedList>
                            {scopedErrors.map((error, index) => (
                                <li key={index}>{error}</li>
                            ))}
                        </UnorderedList>
                    </Banner>
                );
            })}
        </Stack>
    );
};

export default UncaughtErrors;
